// Where an application came from, when a recruiter moved it to another job in the ATS. The ATS keeps the
// application's ref across the move, and the server lists the application once, on the job it is on now
// (AtsReviewerStageActionsService.application_rows), so this note is the only trace of the jobs it left.
//
// Extracted from ApplicationsTab so the wording is testable without mounting the tab.

// The way the row labels its own job: job name, else project name, then the req id.
function jobLabel(job) {
  const name = job?.jobName || job?.projectName;
  if (!name) {
    return null;
  }
  return job.reqId ? `${name} (${job.reqId})` : name;
}

export function movedFromNote(application) {
  const labels = (application?.movedFrom || []).map(jobLabel).filter(Boolean);
  return labels.length ? `Moved from ${labels.join(", ")}` : null;
}
